import { render, staticRenderFns } from "./AuthResetForm.vue?vue&type=template&id=6f0cf3ac&scoped=true&lang=pug&"
import script from "./AuthResetForm.vue?vue&type=script&lang=js&"
export * from "./AuthResetForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthResetForm.vue?vue&type=style&index=0&id=6f0cf3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0cf3ac",
  null
  
)

export default component.exports